export const PER_PAGE_CAMPAIGNS_COUNT = 10;
export const PER_PAGE_ALLCONTACTS_COUNT = 10;
export const PER_PAGE_CLIENTS_COUNT = 10;
export const PER_PAGE_LEADS_COUNT = 10;
export const PER_PAGE_TAGS_COUNT = 10;
